export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AvisoEstudiantes.vue?vue&type=template&id=2e6b01d3&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/AvisoEstudiantes.vue?vue&type=template&id=2e6b01d3&scoped=true&
// module id = 588
// module chunks = 0